export const getSelectYearRange = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 1980 + 1 }, (_, i) => currentYear - i);
}

export const getLabelFromType = (typeList, value) => {
  return typeList.find(type => type.value === value)?.label;
}

export function debounce(fn, delay = 300) {
  let timer

  return (...args) => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}